import {UAParserService} from 'Services/UAParserService';

/**
 * @description Check if the functionality need a polyfill.
 * @param {Array} compatibilityList - Array of object with { browserName, version }.
 * @param {object} browser - Object with the browser info { name: browserName, major: majorVersion }.
 * @returns {boolean} - True if polyfill is needed.
 */
export default function needPolyfill(compatibilityList, browser = UAParserService.getBrowser()) {
    let {name, major} = browser;

    name = name.toUpperCase();
    major = parseInt(major, 10);

    const version = compatibilityList
        .filter(({browserName}) => browserName.toUpperCase() === name)
        .reduce((acc, current) => current.version, '');

    return major <= version;
}
